export const EXPECTED_SORT_CATEGORIES = Object.freeze({
    HOTEL: "hotel",
    FLYER: "flyer",
    FRIEND: "friend",
    SOCIAL_MEDIA: "socialMedia"
})